export default {
  select: {
    border: {
      radius: '{border.radius.none}'
    }
  }
};